'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var video = function video(el) {
  (0, _classCallCheck3.default)(this, video);

  /* Autoplay video on desktop but switch to controls for mobile */
  var screenWidth = document.documentElement.clientWidth;
  var vid = document.getElementById('prd-Video');
  var prdvid = document.getElementById('prd-ProductVideo');
  var mobilecontroller = document.querySelector('.prd-Mobile_Controller');
  var prdmobilecontroller = document.querySelector('.prd-Mobile_ControllerProduct');

  if (screenWidth <= 960) {
    if (typeof vid !== 'undefined' && vid != null) {
      vid.load();

      document.querySelector('.prd-Mobile_Controller').onclick = function () {
        mobilecontroller.classList.add('prd-Mobile_Controller-hide');
        vid.controls = true;
        vid.play();
      };
    }

    if (typeof prdvid !== 'undefined' && prdvid != null) {
      prdvid.load();

      document.querySelector('.prd-Mobile_ControllerProduct').onclick = function () {
        prdmobilecontroller.classList.add('prd-Mobile_Controller-hide');
        prdvid.controls = true;
        prdvid.play();
      };
    }
  } else {
    if (typeof vid !== 'undefined' && vid != null) {
      vid.autoplay = true;
      vid.muted = true;
      vid.loop = true;
      vid.load();
    }

    if (typeof prdvid !== 'undefined' && prdvid != null) {
      prdvid.autoplay = true;
      prdvid.muted = true;
      prdvid.loop = true;
      prdvid.load();
    }
  }
};

exports.default = video;